<template>
  <div @click="selectedInputItem = null; selectedOutputItem = null">
    <breadcrumbs home="Process"/>

      <v-card flat>
        <v-form v-model="valid" ref="form">
          <v-container class="pt-6 px-6 purtrak-scrollable" fluid>
            <v-row dense>
            <v-col cols="12" sm="5">
                <v-text-field label="Name" v-model="process.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
              </v-col>
              <v-col cols="2">
                <v-checkbox label="Active" v-model="process.active" dense class="mt-1"/>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-autocomplete dense outlined label="Preferred still"
                          :items="stills" item-value="id" item-text="name" v-model="process.preferredStillId"/>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col cols="12" md="9">
                <outlined-block title="Inputs" v-model="process.inputs" :rules="[inputsNeeded]">
                  <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                                :items="process.inputs" item-key="key" no-data-text="At least one input item is required"
                                :headers="[{text:'',value:'add',width:'10%',align:'center',cellClass:'pa-0',divider:true},
                                          {text:'Input',value:'type',width:'36%',divider:true,class:'px-2',cellClass:'py-2 px-1'},
                                          {text:'Quantity',value:'quantity',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'},
                                          {text:'Minimum',value:'minQuantity',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'},
                                          {text:'Max (0 for no max)',value:'maxQuantity',width:'18%',divider:true,class:'px-2',cellClass:'py-2 px-1',align:'right'}]"
                                class="no-sort"
                                :item-class="item => item.key === selectedInputItem ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                                @click.native.stop=""
                                @click:row="item => {selectedInputItem = item.key; $nextTick(() => this.$refs.form.validate())}"
                                ref="tableInputs">
                    <template v-slot:item.add="{index}">
                      <v-icon class="handle mt-n2">mdi-drag</v-icon>
                      <v-btn class="mt-n2" icon @click.stop="deleteItem(index)" x-small><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <template v-slot:item.type="{item}">
                      <multi-level-select v-if="selectedInputItem === item.key" :menuData="eligibleInputs" :first.sync="item.type" :second.sync="item.id" @change="changeType(item)"
                                    @addSpirit="outputItem=null;inputItem=item;spiritCreate=true"
                                    @addWine="outputItem=null;inputItem=item;wineCreate=true"
                                    @addNonExcise="outputItem=null;inputItem=item;nonExciseCreate=true"
                                    @addItem="outputItem=null;inputItem=item;itemCreate=true" outlined label="Input"/>
                      <div v-else class="pl-1" :class="{'error--text':!item.type}">
                        {{itemDescription(item)}}
                      </div>
                    </template>
                    <template v-slot:item.quantity="{item}">
                      <decimal-number-input v-if="selectedInputItem === item.key" label="Quantity" v-model="item.quantity" prefix=""
                            :min="item.minQuantity" :max="item.maxQuantity?item.maxQuantity:undefined"
                            :suffix="trackUnits(item)" :precision="precision(item)" class="text-body-2"/>
                      <div v-else class="mr-1" :class="{'error--text':item.quantity < item.minQuantity || (item.maxQuantity && item.quantity > item.maxQuantity)}">
                        {{item.quantity | number(precision(item))}} {{trackUnits(item)}}
                      </div>
                    </template>
                    <template v-slot:item.minQuantity="{item}">
                      <decimal-number-input v-if="selectedInputItem === item.key" label="Min quantity" v-model="item.minQuantity" prefix=""
                            :suffix="trackUnits(item)" :precision="precision(item)" class="text-body-2" @change="$refs.form.validate()"/>
                      <div v-else class="mr-1" :class="{'error--text':item.minQuantity < 0}">{{item.minQuantity | number(precision(item))}} {{trackUnits(item)}}</div>
                    </template>
                    <template v-slot:item.maxQuantity="{item}">
                      <decimal-number-input v-if="selectedInputItem === item.key" label="Max quantity" v-model="item.maxQuantity" prefix=""
                            :suffix="trackUnits(item)" :precision="precision(item)" class="text-body-2" @change="$refs.form.validate()"
                            hint="0 for no max"/>
                      <div v-else class="mr-1" :class="{'error--text':item.maxQuantity < 0}">{{item.maxQuantity | number(precision(item))}} {{trackUnits(item)}}</div>
                    </template>
                    <template v-slot:footer="{widths}">
                      <v-divider/>
                      <div @click="selectedInputItem = null" style="width:100%" class="py-2 px-0">
                        <div :style="'width:'+widths[0]+'px'" class="text-center">
                          <v-btn fab color="primary" x-small @click.stop="addItem"><v-icon small>mdi-plus</v-icon></v-btn>
                        </div>
                      </div>
                    </template>
                  </v-data-table>
                </outlined-block>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="4">
                <v-autocomplete dense outlined label="Scale input items to"
                          :items="inputAlcohol" item-value="id" item-text="name" v-model="process.scaleToId"
                          :disabled="noItemsInput"/>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="7">
                <outlined-block title="Outputs" v-model="process.outputs" :rules="[outputsNeeded]">
                  <v-data-table width="100%" calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                                :items="process.outputs" item-key="spiritId" no-data-text="At least one output spirit is required"
                                :headers="[{text:'',value:'add',width:'15%',align:'center',cellClass:'pa-0',divider:true},
                                          {text:'Output',value:'type',width:'70%',divider:true,class:'pl-2',cellClass:'py-2 px-1'},
                                          {text:'Carry value?',value:'carry',width:'15%',align:'center',divider:true,class:'pl-2',cellClass:'py-2 px-1'}]"
                                class="no-sort"
                                :item-class="item => item.key === selectedOutputItem ? ($vuetify.theme.dark ? 'grey darken-1' : 'grey lighten-4') : ''"
                                @click.native.stop=""
                                @click:row="item => {selectedOutputItem = item.key; $nextTick(() => this.$refs.form.validate())}"
                                ref="tableOutputs">
                    <template v-slot:item.add="{index}">
                      <v-icon class="handle mt-n2">mdi-drag</v-icon>
                      <v-btn class="mt-n2" icon @click.stop="deleteSpirit(index)" x-small><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <template v-slot:item.type="{item}">
                      <multi-level-select v-if="selectedOutputItem === item.key" :menuData="eligibleOutputs" :first.sync="item.type" :second.sync="item.spiritId"
                                    @addSpirit="outputItem=item;inputItem=null;spiritCreate=true"
                                    @addNonExcise="outputItem=item;inputItem=null;nonExciseCreate=true" outlined label="Output"/>
                      <div v-else class="pl-1" :class="{'error--text':!item.type}">
                        {{itemDescription(item)}}
                      </div>
                    </template>
                    <template v-slot:item.carry="{item}">
                      <template>
                        <v-simple-checkbox v-model="item.carryValue" v-if="selectedOutputItem === item.key" class="mt-n5"/>
                        <v-icon v-else-if="item.carryValue">mdi-check</v-icon>
                      </template>
                    </template>
                    <template v-slot:footer="{widths}">
                      <v-divider/>
                      <div @click="selectedOutputItem = null" style="width:100%" class="py-2 px-0">
                        <div :style="'width:'+widths[0]+'px'" class="text-center">
                          <v-btn fab color="primary" x-small @click.stop="addOutput"><v-icon small>mdi-plus</v-icon></v-btn>
                        </div>
                      </div>
                    </template>

                  </v-data-table>
                </outlined-block>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="7">
                <v-textarea label="Production notes" v-model="process.description" outlined dense no-resize :rows="4" :rules="[fieldRules.maxLength(1000)]"/>
              </v-col>
            </v-row>
            <v-row v-if="$store.getters.company.allowPlanning">
              <v-col cols="12" md="6">
                <production-planning :planning="process.productionPlanningInfo"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

        <v-divider/>
        <v-card-actions class="px-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
        </v-card-actions>
      </v-card>

    <confirm-leave v-model="next"/>
    <spirit-quick-create v-model="spiritCreate" @create="spiritCreated"/>
    <wine-quick-create v-model="wineCreate" @create="wineCreated"/>
    <alcohol-non-excise-quick-create v-model="nonExciseCreate" @create="nonExciseCreated"/>
    <inventory-items-quick-create v-model="itemCreate" @create="itemCreated"/>
  </div>
</template>

<script>
import sortableJS from 'sortablejs';
import SpiritQuickCreate from '@/views/alcohol/spirits/SpiritQuickCreate'
import WineQuickCreate from '@/views/alcohol/wine/WineQuickCreate'
import AlcoholNonExciseQuickCreate from '@/views/alcohol/nonExcise/AlcoholNonExciseQuickCreate'
import InventoryItemsQuickCreate from '@/views/inventory/items/InventoryItemsQuickCreate'
import confirmLeave from '@/mixins/confirmLeave'
import ProductionPlanning from '@/views/production/ProductionPlanning'
import createHierarchyList from '@/mixins/createHierarchyList'

export default {
  name: 'ProductionDistillingProcessesEdit',
  mixins: [confirmLeave,createHierarchyList],
  components: {SpiritQuickCreate,WineQuickCreate,AlcoholNonExciseQuickCreate,InventoryItemsQuickCreate,ProductionPlanning},
  props: {
    processId: {type:String, required:false},
    copy: {type:Boolean, required:false}
  },
  data () {
    return {
      process: {inputs:[],outputs:[],productionPlanningInfo:{equipmentTypes:[]}},
      stills: [{id:'',name:'(none)'},{divider:true}],
      items: [],
      spirits: [],
      wines: [],
      nonExcises: [],
      categories: [],
      dirty: false,
      saving: false,
      loading: false,
      valid: true,
      selectedInputItem: null,
      selectedOutputItem: null,
      inputsNeeded: v => !v || v.length>0 || 'At least one input needs to be added to the process',
      outputsNeeded: v => !v || v.length>0 || 'At least one spirit needs to be output',
      spiritCreate: false,
      wineCreate: false,
      nonExciseCreate: false,
      itemCreate: false,
      inputItem: null,
      outputItem: null,
      sortableInput: null,
      sortableOutput: null
    }
  },
  computed: {
    eligibleInputs() {
      const inputs = [];
      inputs.push({name:'Spirit',id:'Spirit',menu:this.spirits,actionEvent:'addSpirit',actionText:'Add new spirit'});
      inputs.push({name:'Mash',id:'Mash'});
      inputs.push({name:'Wine',id:'Wine',menu:this.wines,actionEvent:'addWine',actionText:'Add new wine'});
      inputs.push({name:'Non-excise',id:'NonExcise',menu:this.nonExcises,actionEvent:'addNonExcise',actionText:'Add new non-excise'});
      if (this.categories.length) {
        const categories = this.createHierarchyList(this.categories);
        for (const category of categories) {
          const sub = this.items.filter(ii => ii.category?.id === category.id);
          if (sub.length)
            category.menu = sub;
          else
            category.disabled = true;
        }
        const otherItems = {name:'Other items',id:'x'};
        const leftOver = this.items.filter(ii => !ii.category?.id);
        if (leftOver.length)
          otherItems.menu = leftOver;
        else
          otherItems.disabled = true;
        inputs.push({name:'Item',id:'Item',menu:[...categories, {divider:true}, otherItems],actionEvent:'addItem',actionText:'Add new item'});
      }
      else
        inputs.push({name:'Item',id:'Item',menu:this.items,actionEvent:'addItem',actionText:'Add new item'});
      return inputs;
    },
    eligibleOutputs() {
      const outputs = [];
      outputs.push({name:'Spirit',id:'Spirit',menu:this.spirits,actionEvent:'addSpirit',actionText:'Add new spirit'});
      outputs.push({name:'Non-excise',id:'NonExcise',menu:this.nonExcises,actionEvent:'addNonExcise',actionText:'Add new non-excise'});
      return outputs;
    },
    inputAlcohol() {
      const spirits = this.spirits.filter(spirit => this.process.inputs.some(i => i.type === 'Spirit' && i.id === spirit.id));
      const wines = this.wines.filter(wine => this.process.inputs.some(i => i.type === 'Wine' && i.id === wine.id));
      const nonExcises = this.nonExcises.filter(nonExcise => this.process.inputs.some(i => i.type === 'NonExcise' && i.id === nonExcise.id));
      return [{id:'',name:'(no scaling)'},{divider:true},...spirits,...wines,...nonExcises];
    },
    noItemsInput() {
      return !this.process.inputs.some(i => i.type === 'Item');
    }
  },
  watch: {
    process: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    },
    inputAlcohol() {
      if (this.process.scaleToId && !this.inputAlcohol.some(a => a.id === this.process.scaleToId))
        this.process.scaleToId = '';
    }
  },
  async created() {
    this.loading = true;
    this.$lazyListLoad(this.stills, 'stills2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.categories, 'categories2', 'id,name,parent{id}', 100, [], [{name:'type',value:'Item'}]);
    this.$lazyListLoad(this.items, 'items2', 'id,name,trackUnits,precision,category{id}', 100, this.processId?[]:[{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.spirits, 'spirits2', 'id,name', 100, this.processId ? [] : [{field:'active', comparator:'eq', value:'true'}]);
    if (this.$store.getters.company.allowWine)
      this.$lazyListLoad(this.wines, 'wines2', 'id,name', 100, this.processId ? [] : [{field:'active', comparator:'eq', value:'true'}]);
    this.$lazyListLoad(this.nonExcises, 'nonExcises2', 'id,name', 100, this.processId ? [] : [{field:'active', comparator:'eq', value:'true'}]);

    if (this.processId) {
      const results = await this.$apiCall(`query ProductionDistillingProcessesEdit($id:ID!) {
                                                process(id:$id) {
                                                  id,name,active,preferredStillId,scaleToId,inputs{type,id,quantity,minQuantity,maxQuantity},outputs{spiritId,carryValue,nonExcise},description
                                                  productionPlanningInfo {useAverageDuration,specifiedDuration,equipmentTypes{id,quantity},roleId}
                                                }
                                              }`,
                                          {id:this.processId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      let key = Date.now();
      results.data.process.inputs.forEach(input => input.key = key++);
      results.data.process.outputs.forEach(output => {output.key = key++; output.type = output.nonExcise ? 'NonExcise' : 'Spirit'});
      this.process = results.data.process;
      if (this.copy) {
        delete this.process.id;
        this.process.active = true;
        this.process.name = `COPY OF ${this.process.name}`;
      }
    }

    else
      this.process = {name:'',active:true,preferredStillId:'',inputs:[],outputs:[],scaleToId:'',description:'',
                      productionPlanningInfo:{useAverageDuration:true,specifiedDuration:0,equipmentTypes:[],roleId:''}};

    this.$nextTick(() => this.dirty = false);
    this.loading = false;
  },
  mounted() {
    const _self = this;
    this.sortableInput = sortableJS.create(this.$refs.tableInputs.$el.querySelector('tbody'), {
      handle: '.handle',
      onEnd({newIndex, oldIndex}) {
        const rowSelected = _self.process.inputs.splice(oldIndex, 1)[0];
        _self.process.inputs.splice(newIndex, 0, rowSelected);
      }
    })

    this.sortableOutput = sortableJS.create(this.$refs.tableOutputs.$el.querySelector('tbody'), {
      handle: '.handle',
      onEnd({newIndex, oldIndex}) {
        const rowSelected = _self.process.outputs.splice(oldIndex, 1)[0];
        _self.process.outputs.splice(newIndex, 0, rowSelected);
      }
    })
  },
  beforeDestroy() {
    this.sortableInput.destroy();
    this.sortableOutput.destroy();
  },

  methods: {
    itemDescription(item) {
      if (!item.type)
        return 'MISSING';
      if (item.type === 'Mash')
        return 'Mash';
      const lists = {'Spirit':this.spirits,'Wine':this.wines,'NonExcise':this.nonExcises,'Item':this.items};
      return `${item.type}: ${lists[item.type]?.find(i => i.id === item.id || i.id === item.spiritId)?.name}`;
    },
    spiritCreated(spirit) {
      this.spirits.push(spirit);
      if (this.inputItem) {
        this.inputItem.type = 'Spirit';
        this.inputItem.id = spirit.id;
      }
      else if (this.outputItem) {
        this.outputItem.type = 'Spirit';
        this.outputItem.spiritId = spirit.id;
      }
    },
    async itemCreated(item) {
      this.items = (await this.$store.dispatch('items')).filter(item => item.active);
      if (this.inputItem) {
        this.inputItem.type = 'Item';
        this.inputItem.id = item.id;
      }
    },
    wineCreated(wine) {
      this.wines.push(wine);
      if (this.inputItem) {
        this.inputItem.type = 'Wine';
        this.inputItem.id = wine.id;
      }
    },
    nonExciseCreated(nonExcise) {
      this.nonExcises.push(nonExcise);
      if (this.inputItem) {
        this.inputItem.type = 'NonExcise';
        this.inputItem.id = nonExcise.id;
      }
      else if (this.outputItem) {
        this.outputItem.type = 'NonExcise';
        this.outputItem.spiritId = nonExcise.id;
      }
    },
    changeType(item) {
      item.quantity = 0;
      item.minQuantity = 0;
      item.maxQuantity = 0;
      this.$nextTick(() => this.$refs.form.validate());
    },
    precision(item) {
      if (item.id === '' && item.type !== 'Mash')
        return 0;
      return item.type === 'Item' ?  this.items.find(i => i.id === item.id).precision : 3;
    },
    trackUnits(item) {
      if (item.id === '' && item.type !== 'Mash')
        return '';
      if (item.type === 'Spirit')
        return 'LAA'
      return item.type === 'Item' ? this.items.find(i => i.id === item.id).trackUnits : 'litres';
    },
    addItem() {
      const key = Date.now();
      this.process.inputs.push({key,type:'',id:null,quantity:0,minQuantity:0,maxQuantity:0,key:Date.now()});
      this.selectedInputItem = key;
      this.$nextTick(() => this.$refs.form.validate());
    },
    deleteItem(index) {
      this.process.inputs.splice(index, 1);
    },
    addOutput() {
      const key = Date.now();
      this.process.outputs.push({key,spiritId:null,carryValue:true,type:''});
      this.selectedOutputItem = key;
      this.$nextTick(() => this.$refs.form.validate());
    },
    deleteSpirit(index) {
      this.process.outputs.splice(index, 1);
    },
    cancel() {
      this.$router.back();
    },
    async save() {
      const incomplete = this.process.inputs.some(item => !item.type ||
                                                  item.quantity < item.minQuantity || (item.maxQuantity && item.quantity > item.maxQuantity) ||
                                                  item.minQuantity < 0 || item.maxQuantity < 0) ||
                         this.process.outputs.some(item => !item.spiritId);
      if (!this.valid || incomplete) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }
      this.saving = true;
      // eslint-disable-next-line no-unused-vars
      const {inputs, ...input} = this.process;
      input.inputs = this.process.inputs.map(input => ({type:input.type,minQuantity:input.minQuantity,maxQuantity:input.maxQuantity,
                                                        id:input.type==='Item' || input.type==='Spirit' || input.type==='Wine' || input.type==='NonExcise' ? input.id : undefined,
                                                        quantity:input.quantity}));
      input.outputs = this.process.outputs.map(output => ({spiritId:output.spiritId,carryValue:output.carryValue}));
      const results = await this.$apiCall(`mutation ProductionDistillingProcessesEdit($input: ProcessInput!) {
                                             processCreate(input:$input) {id}
                                           }`,
                                          {input})
      this.saving = false;
      if (!results.error) {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.process.id?'Updated':'Created'} process ${this.process.name}`});
      }
    }
  }
}
</script>